import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=c5f481a6&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=c5f481a6&prod&lang=scss&scoped=true"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=c5f481a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f481a6",
  null
  
)

export default component.exports